export enum ReservationTicket {
  entranceTicket = 1,
  organizedSchool,
  freeEntry,
  groupOffers,
  guidedTours,
  tourismCompanies,
  officialInstitutions,
  friendsOfOmanMuseum,
  exhibitionsAndEvents,
  packages,
  products,
}
